module.exports = __webpack_public_path__ + "static/media/5.15_preview.32e09853.png";